// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridContainer, GridItem } from "@insite/mobius/index";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@werner/App/Components/Common/XngZone";
import { DivWrapper } from "@werner/XDL/constants";
import { color, xScreen } from "@werner/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

interface AccountSettingsPageLayoutStyles {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    userInformationGridItem?: GridItemProps;
    billingAndShippingGridItem?: GridItemProps;
}

const accountSettingsPageLayout: AccountSettingsPageLayoutStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    container: {
        gap: 20,
        css: css`
            margin-top: 52px;
            ${xScreen("lte", "sm")} {
                margin-top: 24px;
            }
        `,
    },
    userInformationGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            flex-direction: column;
            gap: 16px;
        `,
    },
    billingAndShippingGridItem: {
        width: [12, 12, 7, 7, 7],
    },
};

const styles = accountSettingsPageLayout;
const AccountSettingsPageLayout: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="AccountSettingsPageLayout">
            <XngZone contentId={id} zoneName="PageHeaderZone" hint="Page Header" />
            <GridContainer {...styles.container}>
                <GridItem {...styles.userInformationGridItem}>
                    <XngZone contentId={id} zoneName="AccountSettingsUserInformationZone" hint="User Information" />
                    <XngZone contentId={id} zoneName="AccountSettingsSubscribe" hint="Custom Subscribe Zone" />
                </GridItem>
                <GridItem {...styles.billingAndShippingGridItem}>
                    <XngZone
                        contentId={id}
                        zoneName="AccountSettingsDefaultBillingShippingZone"
                        hint="Default Billing and Shipping"
                    />
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: AccountSettingsPageLayout,
    definition: {
        group: "Layout" as any,
        displayName: "Account Settings layout",
        allowedContexts: ["AccountSettingsPage"],
    },
};

export default widgetModule;
